import {BrowserModule, Meta, Title} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule, routes} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {HTTP_INTERCEPTORS, HttpBackend, HttpClient, HttpClientModule} from '@angular/common/http';
import {translateHttpFactory} from '@shared/i18n/translation.loader';
import {DwMissingTranslationHandler} from '@shared/i18n/dwMissingTranslationHandler';
import {
  LocalizeParser,
  LocalizeRouterModule,
  LocalizeRouterSettings,
  ManualParserLoader
} from '@gilsdav/ngx-translate-router';
import {Location} from '@angular/common';
import {SharedModule} from './modules/shared/shared.module';
import {CookieModule} from 'ngx-cookie';
import {NotFoundPage} from '@components/common';
import {RequestInterceptor} from '@interceptors/request.interceptor';
import {ModalService} from '@services/modal/modal.service';
import {ErrorService} from '@services/error/error.service';
import {NgxsModule, NoopNgxsExecutionStrategy} from '@ngxs/store';
import {environment} from '@env/environment';
import {NgxsLoggerPluginModule} from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import {ErrorInterceptor} from '@interceptors/error.interceptor';
import {NgxStripeModule} from 'ngx-stripe';
import {NgxsResetPluginModule} from 'ngxs-reset-plugin';
import {dwallState} from './store';
import {NgxsRouterPluginModule, RouterStateSerializer} from '@ngxs/router-plugin';
import {CustomRouterStateSerializer} from '@store/router/router-state.serializer';
import {advertiserState} from './store-advertiser';
import {NGXS_DATA_CONFIG, NgxsDataPluginModule} from '@angular-ru/ngxs';
import {AbilityModule} from '@casl/angular';
import {Ability, PureAbility} from '@casl/ability';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundPage
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    CookieModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateHttpFactory,
        deps: [HttpBackend],
      },
      missingTranslationHandler: {provide: MissingTranslationHandler, useClass: DwMissingTranslationHandler},
      useDefaultLang: false,
    }),
    LocalizeRouterModule.forRoot(routes, {
      initialNavigation: true,
      useCachedLang: false,
      // Replaced with default browser language
      defaultLangFunction: () => 'eng',
      parser: {
        provide: LocalizeParser,
        useFactory: (translate: TranslateService, location: Location, settings: LocalizeRouterSettings) =>
          new ManualParserLoader(translate, location, settings, ['eng', 'ukr']),
        deps: [TranslateService, Location, LocalizeRouterSettings, HttpClient],
      },
      alwaysSetPrefix: false,
    }),
    AppRoutingModule,
    NgxsModule.forRoot(dwallState, {
      developmentMode: !environment.production,

      // TODO: fix issue with modal window in store
      // & remove property below to increase performance
      executionStrategy: NoopNgxsExecutionStrategy
    }),
    NgxsRouterPluginModule.forRoot(),
    NgxsResetPluginModule.forRoot(),
    NgxsDataPluginModule.forRoot([advertiserState]),
    NgxsReduxDevtoolsPluginModule.forRoot({disabled: environment.production}),
    NgxsLoggerPluginModule.forRoot({disabled: environment.production}),
    NgxStripeModule.forRoot(environment.stripeKey),
    AbilityModule,
  ],
  providers: [
    Meta,
    Title,
    ModalService,
    ErrorService,
    { provide: NGXS_DATA_CONFIG, useValue: { dataActionSubscribeRequired: false } },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },
    { provide: Ability, useValue: new Ability() },
    { provide: PureAbility, useExisting: Ability }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
